<template>
  <div class="myAdmissionTicket">
     <van-nav-bar class="page_nav" title="我的准考证" left-arrow @click-left="onClickLeft" :fixed="true" />
    <div class="placeholder_box" style="height:46PX"></div>
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        ref="list"
        @load="onLoad"
        v-show="ticketsList && ticketsList.length"
      >
        <div class="grade_item" v-for="item in ticketsList" :key="item.ucode">
            <p class="tb_title">{{item.certName}}</p>
            <span class="view_btn" @click="viewTicket(item)">查看</span>
        </div>
    </van-list>
    <div class="noContent" v-if="!ticketsList.length">
        <img src="./assets/images/no_examplan.png" />
        <p class="trainging-noContent">暂无数据~</p>
    </div>
    <!-- 准考证内容 S -->
    <div style="position:absolute;left:0;z-index:-1;opacity:0;width:0;height:0;overflow:hidden;">
      <div class="cert_wrap" ref="certWrap" >
        <div class="certLeftBox">
          <p class="exam_title">{{certInfo.certName}}准考证</p>
          <table id="cert_table" border="1" cellspacing="0" cellpadding="0" width="100%" style="table-layout:fixed;border-collapse:collapse;">
            <tr>
              <td colspan="3" width="18.75%" class="title">姓名</td>
              <td colspan="4" width="25%">{{certInfo.userName}}</td>
              <td colspan="2" width="13.5%" class="title">性别</td>
              <td colspan="3" width="18.75%">{{certInfo.gender}}</td>
              <td rowspan="4" colspan="4" width="25%">
                <img :src="trueLocalPhoto" class="photo" />
              </td>
            </tr>
            <tr>
              <td colspan="3" width="18.75%" class="title">准考证号</td>
              <td colspan="4" width="25%">{{certInfo.certNumber}}</td>
              <td colspan="2" width="13.5%" class="title">级别</td>
              <td colspan="3" width="18.75%">{{certInfo.level}}</td>
            </tr>
            <tr>
              <td colspan="3" width="18.75%" class="title">证件号</td>
              <td colspan="9" width="56.25%">{{certInfo.idCard}}</td>
            </tr>
            <tr>
              <td colspan="3" width="18.75%" class="title">考试职业</td>
              <td colspan="9" width="56.25%">{{certInfo.vocation}}</td>
            </tr>
            <tr>
              <td colspan="3" width="18.75%" class="title">考试地点</td>
              <td colspan="13" width="81.25%">{{certInfo.siteName}}</td>
            </tr>
            <tr>
              <td colspan="3" width="18.75%" class="title">考试类型</td>
              <td colspan="4" width="25%">{{certInfo.examType}}</td>
              <td colspan="3" width="18.75%" class="title">考核科目</td>
              <td colspan="6" width="37.5%">{{certInfo.subject}}</td>
            </tr>
            <tr>
              <td colspan="3" width="18.75%" class="title">考试安排</td>
              <td colspan="6" width="37.5%" class="title">考试时间</td>
              <td colspan="5" width="31.25%" class="title">试室</td>
              <td colspan="2" width="13.5%" class="title">座位</td>
            </tr>
            <tr class="subject_item" v-for="(item,index) in certInfo.certItemDtoList" :key="index">
              <td colspan="3" width="18.75%" align="center">{{item.subjectName}}</td>
              <td colspan="6" width="37.5%" align="center">{{item.examTime}}</td>
              <td colspan="5" width="31.25%" align="center">{{item.roomName}}</td>
              <td colspan="2" width="13.5%" align="center">{{item.seatNumber}}</td>
            </tr>
            <tr>
              <td colspan="3" width="18.75%" class="title">综合评审</td>
              <td colspan="13" width="81.25%">&nbsp;</td>
            </tr>
            <!-- <tr v-if="certInfo.certItemDtoList" :style="`height:calc(718PX - 8 * 45PX - 45PX * ${certInfo.certItemDtoList.length})`"> -->
            <tr style="height:270PX;">
              <td colspan="3" width="18.75%" class="title">注意事项</td>
              <td colspan="13" width="81.25%" class="rules_txt1 rules_txt">{{innerText1}}</td>
            </tr>
          </table>
        </div>
        <div class="certRightBox" v-show="innerText2">
          <p class="exam_title">{{certInfo.certName}}考场守则</p>
          <div class="rules_txt main_h" id="shouze_wrap">{{innerText2}}</div>
        </div>
        <!-- 添加水印 -->
        <div class="watermark">
         {{certInfo.certName}}
        </div>
      </div>
    </div>
    <!-- 准考证内容 E -->
    <!-- 准考证弹出框预览 -->
    <div class="ticket_dialog" v-if="ticketViewShow">
      <div class="d_body">
        <div class="cont">
          <img :src="ticketImg" class="ticket_img" />
          <p class="tips">温馨提示：请于考试前完成准考证下载及打印</p>
        </div>
        <img class="saveImgTip" src="./assets/images/saveImgTip.png" />
        <img class="close_icon" src="../../../assets/images/common/close-icon.png" @click="ticketViewShow = false" />
      </div>
    </div>
    <!-- 加载中 -->
    <van-overlay :show="showLoading" class="overlay_box">
      <van-loading size="24px" vertical>准考证生成中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
export default {
  name: "myAdmissionTicket",
  data() {
    return {
      showLoading:false,
      canClick:true,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      ticketsList: [],
      ticketViewShow: false,
      ticketImg: "",
      //
      certInfo: {},
      trueLocalPhoto: "",
      innerText1: "",
      innerText2: "",
      timer1:null,
      timer2:null
    };
  },
  mounted() {
    this.getData();
  },
  destroyed() {
    clearTimeout(this.timer1);
    clearTimeout(this.timer2);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getData() {
      this.$api.rensheDistributionExam
        .getMyCertList({ pageNum: this.pageNum, pageSize: this.pageSize })
        .then(res => {
          if (res.data && res.data.list) {
            this.ticketsList = this.ticketsList.concat(res.data.list);
            // this.total = res.data.total;
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成
            this.finished = res.data.isLastPage;
          }
        });
    },
    onLoad() {
      console.log(1111)
      this.pageNum ++;
      this.getData();
    },
    viewTicket(item) {
      if(!this.canClick){
        return;
      }
      this.canClick = false;
      this.showLoading = true;
      let { certName, ucode } = item;
      this.certInfo ={};
      this.trueLocalPhoto ="";
      this.$api.rensheDistributionExam
        .createMyCert({
          certName,
          ucode
        })
        .then(res => {
          if (res.success) {
            this.certInfo = res.data;
            //处理数据
            // const wordnum =
            //   Math.floor(
            //     (720 -
            //       8 * 45 -
            //       45 * (this.certInfo.certItemDtoList && this.certInfo.certItemDtoList.length || 0) -
            //       18) /
            //       24
            //   ) * 31;
            let instructions = this.certInfo.instructions.replace(/<[^>]+>/g,"").replace(/&nbsp;/ig, "");
            let content = this.certInfo.content.replace(/<[^>]+>/g,"").replace(/&nbsp;/ig, "");
            // this.innerText1 = content.slice(0, wordnum);
            // this.innerText2 = content.slice(wordnum);
            this.innerText1 = instructions;
            this.innerText2 = content;
            this.createPicture(item);
          }else{
            this.canClick = true;
            this.showLoading = false;
          }
        }).catch(()=>{
          this.canClick = true;
          this.showLoading = false;
        })
    },
    createPicture(item) {
      const currentHostname = window.location.hostname;
      let envArr = ['testing1', 'testing2', 'testing3', 'fat', 'uat'];
      let env = window.location.port ? 'testing3' : '';
      envArr.forEach(d => {
        if (window.location.hostname.includes(d)) {env = d}
      })
      let _that = this;
      this.timer1 = null;
      this.timer2 = null;
      if(this.certInfo.photo){
        let photoHostName = '';
        if(env){
          photoHostName = this.certInfo.photo.replace(/^https:\/\/[^/]+\/hrss/, `https://${currentHostname}/hrss-test`);
        }else{
          photoHostName = this.certInfo.photo.replace(/^https:\/\/[^/]+\/hrss/, `https://${currentHostname}/hrss-prod`);
        }
        let image = new Image();
        image.crossOrigin = "";
        image.src = photoHostName;
        console.log(photoHostName);
        image.onload = function() {
          console.log('图片加载了');
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL("image/png",0.7); //得到图片的base64编码数据
          _that.trueLocalPhoto = url;
          console.log(33333)
          //
          _that.timer1 = setTimeout(() => {
            html2canvas(_that.$refs.certWrap, {
              // width: 540,
              // height: 740,
              // dpi: 300,//清晰度问题
              background: "#FFFFFF",
              scrollX: 0,
              scrollY: 0,
              useCORS: true 
            })
              .then(canvas => {
                const imgData = canvas.toDataURL("image/png",0.7);
                console.log("===imgData===", imgData);
                _that.ticketImg = imgData;
                _that.ticketViewShow = true;
                _that.canClick = true;
                _that.showLoading = false;
                let { certName, ucode } = item;
                _that.$api.rensheDistributionExam.downLoadMyCert({
                  certName,
                  ucode
                }).then(res=>{
                  console.log('下载成功');
                })
              })
              .catch(error => {
                console.log(error,'error');
                _that.canClick = true;
                _that.showLoading = false;
              });
          }, 20);
        };
      }else{
        //不应该出现的情况
        _that.timer2 = setTimeout(() => {
            html2canvas(_that.$refs.certWrap, {
              // width: 540,
              // height: 740,
              // dpi: 300,//清晰度问题
              background: "#FFFFFF",
              scrollX: 0,
              scrollY: 0,
              useCORS: true 
            })
              .then(canvas => {
                const imgData = canvas.toDataURL("image/png",0.7);
                console.log("===imgData2===", imgData);
                _that.ticketImg = imgData;
                _that.ticketViewShow = true;
                _that.canClick = true;
                _that.showLoading = false;
              })
              .catch(error => {
                console.log(error,'error2');
                _that.canClick = true;
                _that.showLoading = false;
              });
          }, 60);
      }
    }
  }
};
</script>

<style scoped lang="stylus">
.myAdmissionTicket {
  width:100%;
  min-height: 100vh;
  background: #F8F9FA;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.page_nav {
  position: fixed;
}

.grade_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 690px;
  min-height: 106px;
  background: #FFFFFF;
  border-radius: 14px;
  margin: 16px auto;
  padding: 32px 24px;
  box-sizing: border-box;

  .tb_title {
    font-size: 30px;
    color: #333;
    line-height: 42px;
  }

  .view_btn {
    width: 106px;
    height: 56px;
    border-radius: 32px;
    border: 1px solid #3760FF;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3760FF;
    margin-left: 58px;
    flex-shrink: 0;
    box-sizing: border-box;
    text-align: center;
    line-height: 54px;
  }
}

.noContent {
  text-align: center;
  padding-top: 26%;

  img {
    width: 484px;
    height: 300px;
  }

  .trainging-noContent {
    color: #999999;
    font-size: 28px;
    font-weight: 400;
    margin-top: 16px;
    line-height: 40px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
}

// 
.ticket_dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  .d_body {
    width: 680px;

    .cont {
      width: 680px;
      height: 544px;
      background: #FFFFFF;
      border-radius: 16px;
      margin: 0 auto;
      padding: 24px;
      box-sizing: border-box;
      font-size: 0;

      .ticket_img {
        width: 100%;
        height: 434px;
      }

      .tips {
        font-size: 26px;
        color: #F1430D;
        line-height: 37px;
        margin-top: 24px;
      }
    }

    .downLoad_btn {
      display: block;
      width: 560px;
      height: 88px;
      background: #3760FF;
      border-radius: 44px;
      margin: 56px auto 0;
      font-size: 30px;
      color: #FFFFFF;
      line-height: 88px;
      text-align: center;
    }
    .saveImgTip{
      display:block;
      width:400px;
      height:45px;
      margin:32px auto 0;
    }

    .close_icon {
      display: block;
      width: 48px;
      height: 48px;
      margin: 56px auto 0;
    }
  }
}
// 证书内容
.cert_wrap {
  position:absolute;
  left:0;
  top:0;
  width: 1200PX;
  padding: 24PX;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;

  table {
    color: #333;
    border-color: #606060;

    tr {
      color: #444;
    }

    td {
      font-size: 18PX;
      line-height: 44PX;
      height: 44PX;
      padding: 0 8PX;
      color: #444;

      &.title {
        font-weight: bold;
        text-align: center;
        color: #333;
        font-size: 20PX;
      }

      .photo {
        width: 102PX;
        height: 154PX;
        display: block;
        margin: 0 auto;
      }
    }
  }

  .exam_title {
    font-size: 30PX;
    line-height: 30PX;
    font-family: SimSong-Bold, SimSong;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 24PX;
  }

  .rules_txt1 {
    padding-top: 8PX;
    padding-bottom: 8PX;
  }

  .rules_txt {
    font-size: 14PX;
    line-height: 24PX;
    color: #444;
    box-sizing: border-box;
    word-break: break-all;
  }

  .certLeftBox {
    // width: 568PX;
    flex:1;
    flex-shrink: 0;
  }

  .certRightBox {
    width: 556PX;
    flex-shrink: 0;
    box-sizing: border-box;
    margin-left:30px;

    .main_h {
      height: 720PX;
      box-sizing: border-box;
      // border:1px solid #606060;
      padding:8PX;
      // overflow:auto;
    }
  }
  .watermark{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    font-size: 56PX;
    font-family: AlibabaPuHuiTiB;
    color: rgba(54, 75, 192, .3);
    line-height: 77PX;
    font-weight:600;
    white-space: nowrap;
  }
}
.overlay_box{
  display:flex;
  align-items:center;
  justify-content:center;
  /deep/ .van-loading--vertical{
    color:rgba(255,255,255,.8)!important;
    .van-loading__text {
      color:rgba(255,255,255,.8)!important;
    }
  }
  
}
</style>
